"use client";

import React from "react";
import { Button } from "../ui/button";
import { Shield, Menu, X, User, LogOut, Settings } from "lucide-react";
import { useState } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import Link from "next/link";
import { usePathname } from "next/navigation";
import Image from "next/image";
import { useUser } from "@/context/userContext";
// interface HeaderProps {
//   isAuthenticated?: boolean;
//   user?: any;
//   logout?: () => void;
// }

export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const pathname = usePathname();
  const { user, isAuthenticated, logout } = useUser();

  const navItems = [
    { href: "/", label: "Home" },
    // { href: "/check-plagiarism", label: "Check Plagiarism" },
    { href: "/features", label: "Features" },
    { href: "/pricing", label: "Pricing" },
    { href: "/about", label: "About" },
  ];
  return (
    <header className="bg-white shadow-sm sticky top-0 z-50 border-b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link href="/" className="flex items-center space-x-2">
            <Image
              src="/logo/color-logo.png"
              width={120}
              height={27}
              alt="PlagPro Logo"
            />
          </Link>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.href}
                href={item.href}
                className={`transition-colors duration-200 ${
                  pathname === item.href
                    ? "text-blue-600 font-medium"
                    : "text-gray-700 hover:text-blue-600"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          {/* Auth Section */}
          <div className="hidden md:flex items-center space-x-4">
            {isAuthenticated ? (
              <>
                {/* <Link
                  href={"/check-plagiarism"}
                  // variant="outline"
                  // onClick={() => setCurrentPage('checker')}
                >
                  New Check
                </Link> */}
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <Button
                      variant="ghost"
                      className="flex items-center space-x-2"
                    >
                      <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                        <User className="w-4 h-4 text-blue-600" />
                      </div>
                      <span className="font-medium">{`${user?.first_name} ${user?.last_name}`}</span>
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end" className="w-56">
                    {/* <div className="px-3 py-2">
                      <p className="text-sm font-medium">{userData.name}</p>
                      <p className="text-xs text-gray-500">{userData.email}</p>
                      <p className="text-xs text-blue-600">{userData.plan} Plan</p>
                    </div> */}
                    {/* <DropdownMenuSeparator /> */}
                    <Link
                      href={user?.role_name === "Admin" ? "/admin" : "/user"}
                    >
                      <DropdownMenuItem
                      // onClick={() => setCurrentPage('admin')}
                      >
                        <Settings className="w-4 h-4 mr-2" />
                        Dashboard
                      </DropdownMenuItem>
                    </Link>
                    {/* <DropdownMenuItem

                    // onClick={() => setCurrentPage('checker')}
                    >
                      <Shield className="w-4 h-4 mr-2" />
                      Check Document
                    </DropdownMenuItem> */}
                    <DropdownMenuSeparator />
                    <DropdownMenuItem onClick={logout}>
                      <LogOut className="w-4 h-4 mr-2" />
                      Sign Out
                    </DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              </>
            ) : (
              <>
                <Link href="/login">
                  <Button
                    variant="outline"
                    // onClick={() => setCurrentPage('login')}
                    className="cursor-pointer"
                  >
                    Sign In
                  </Button>
                </Link>

                <Link href="/register">
                  <Button
                    // onClick={() => setCurrentPage('register')}
                    className="bg-blue-600 hover:bg-blue-700 cursor-pointer"
                  >
                    Get Started
                  </Button>
                </Link>
              </>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t bg-white py-4">
            <nav className="flex flex-col space-y-4">
              {navItems.map((item) => (
                <Link
                  key={item.href}
                  href={item.href}
                  onClick={() => setMobileMenuOpen(false)}
                  className={`text-left px-4 py-2 rounded-lg transition-colors duration-200 ${
                    pathname === item.href
                      ? "text-blue-600 bg-blue-50 font-medium"
                      : "text-gray-700 hover:text-blue-600 hover:bg-gray-50"
                  }`}
                >
                  {item.label}
                </Link>
              ))}
              <div className="flex flex-col space-y-2 px-4 pt-4 border-t">
                {isAuthenticated ? (
                  <>
                    <div className="pb-2">
                      {/* <p className="text-sm font-medium">{userData.name}</p> */}
                      <p className="text-sm font-medium">{user?.first_name}</p>
                      <p className="text-xs text-gray-500">
                        {user?.email_address}
                      </p>
                    </div>
                    <Link
                      href={user?.role_name === "Admin" ? "/admin" : "/user"}
                    >
                      <Button
                        variant="outline"
                        onClick={() => {
                          // setCurrentPage('admin');
                          setMobileMenuOpen(false);
                        }}
                        className="w-full"
                      >
                        Dashboard
                      </Button>
                    </Link>
                    <Link href="/check-plagiarism">
                      <Button
                        onClick={() => {
                          // setCurrentPage('checker');
                          setMobileMenuOpen(false);
                        }}
                        className="w-full bg-blue-600 hover:bg-blue-700"
                      >
                        New Check
                      </Button>
                    </Link>
                    <Button
                      variant="ghost"
                      onClick={() => {
                        // onLogout?.();
                        setMobileMenuOpen(false);
                        logout();
                      }}
                      className="w-full"
                    >
                      Sign Out
                    </Button>
                  </>
                ) : (
                  <>
                    <Link href="/login">
                      <Button
                        variant="outline"
                        onClick={() => {
                          // setCurrentPage('login');
                          setMobileMenuOpen(false);
                        }}
                        className="w-full"
                      >
                        Sign In
                      </Button>
                    </Link>
                    <Button
                      onClick={() => {
                        // setCurrentPage('register');
                        setMobileMenuOpen(false);
                      }}
                      className="w-full bg-blue-600 hover:bg-blue-700"
                    >
                      Get Started
                    </Button>
                  </>
                )}
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
